import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-mgt/api/vs/manage-bank-account';

const listByMerchant = (mid) => {
	return Client.get(
		`${baseUrl}/merchant/all/bank-accounts/${mid}/stripe`,
		{},
		{
			timeout: 60000,
		}
	);
};

const list = (userId) => {
	return Client.get(`${baseUrl}/bank-accounts/${userId}`);
};

const find = (merchantId, bankAccountId) => {
	return Client.get(`${baseUrl}/bank-accounts/${merchantId}/${bankAccountId}`);
};

// Not used, use remove -> create instead.
const update = (bankAccountId, payload) => {
	return Client.get(`${baseUrl}/customer/${bankAccountId}`, payload);
};

const remove = (bankAccountId) => {
	return Client.del(`${baseUrl}/customer/${bankAccountId}`);
};

const create = (userId, paymentMethodType, operateBy, subKeyIntention) => {
	return Client.post(`${baseUrl}/customer/${userId}`, {
		paymentMethodType,
		operateBy,
		paymentChannel: 'Stripe',
		subKeyIntention,
	});
};

const confirm = (
	userId,
	setupIntentId,
	paymentMethodId,
	operateBy,
	subKeyIntention
) => {
	return Client.post(`${baseUrl}/customer/${userId}/confirm`, {
		setupIntentId,
		paymentMethodId,
		operateBy,
		paymentChannel: 'Stripe',
		subKeyIntention,
	});
};

const cancel = (userId, setupIntentId, operateBy, subKeyIntention) => {
	return Client.post(`${baseUrl}/customer/${userId}/cancel`, {
		setupIntentId,
		operateBy,
		paymentChannel: 'Stripe',
		subKeyIntention,
	});
};

export default {
	listByMerchant,
	list,
	find,
	create,
	update,
	remove,
	confirm,
	cancel,
};
